export const ProgramRecommendationsIcon = ({
  className,
  strokeColor = 'currentColor',
}: {
  className?: string
  strokeColor?: string
}) => (
  <svg
    className={className}
    fill='none'
    height='20'
    viewBox='0 0 14 20'
    width='14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask fill='white' id='program-recommendations-icon-mask'>
      <path d='M7 0C10.866 0 14 3.13401 14 7C14 9.35765 12.8342 11.4427 11.0479 12.711C10.6146 13.0187 10.3154 13.4974 10.3154 14.0288C10.3154 14.8267 9.66854 15.4736 8.87055 15.4736H5.12945C4.33146 15.4736 3.68457 14.8267 3.68457 14.0288C3.68457 13.4974 3.38542 13.0187 2.95213 12.711C1.16575 11.4427 0 9.35765 0 7C0 3.13401 3.13401 0 7 0Z' />
    </mask>
    <path
      d='M2.95213 12.711L2.08375 13.9341L2.95213 12.711ZM11.0479 12.711L10.1795 11.4879L11.0479 12.711ZM7 0V1.5C10.0376 1.5 12.5 3.96243 12.5 7H14H15.5C15.5 2.30558 11.6944 -1.5 7 -1.5V0ZM14 7H12.5C12.5 8.85107 11.5868 10.4888 10.1795 11.4879L11.0479 12.711L11.9162 13.9341C14.0817 12.3966 15.5 9.86422 15.5 7H14ZM8.87055 15.4736V13.9736H5.12945V15.4736V16.9736H8.87055V15.4736ZM2.95213 12.711L3.8205 11.4879C2.41322 10.4888 1.5 8.85107 1.5 7H0H-1.5C-1.5 9.86422 -0.081714 12.3966 2.08375 13.9341L2.95213 12.711ZM0 7H1.5C1.5 3.96243 3.96243 1.5 7 1.5V0V-1.5C2.30558 -1.5 -1.5 2.30558 -1.5 7H0ZM3.68457 14.0288H5.18457C5.18457 12.9155 4.56473 12.0163 3.8205 11.4879L2.95213 12.711L2.08375 13.9341C2.13683 13.9718 2.16695 14.0101 2.18005 14.0329C2.19136 14.0526 2.18457 14.0499 2.18457 14.0288H3.68457ZM5.12945 15.4736V13.9736C5.15989 13.9736 5.18457 13.9983 5.18457 14.0288H3.68457H2.18457C2.18457 15.6552 3.50304 16.9736 5.12945 16.9736V15.4736ZM10.3154 14.0288H8.81543C8.81543 13.9983 8.84011 13.9736 8.87055 13.9736V15.4736V16.9736C10.497 16.9736 11.8154 15.6552 11.8154 14.0288H10.3154ZM11.0479 12.711L10.1795 11.4879C9.43528 12.0163 8.81543 12.9155 8.81543 14.0288H10.3154H11.8154C11.8154 14.0499 11.8086 14.0526 11.82 14.0329C11.833 14.0101 11.8632 13.9718 11.9162 13.9341L11.0479 12.711Z'
      fill={strokeColor}
      mask='url(#program-recommendations-icon-mask)'
    />
    <line
      stroke={strokeColor}
      strokeLinecap='round'
      strokeWidth='1.5'
      x1='4.80273'
      x2='9.19747'
      y1='16.9343'
      y2='16.9343'
    />
    <line
      stroke={strokeColor}
      strokeLinecap='round'
      strokeWidth='1.5'
      x1='5.53906'
      x2='8.46012'
      y1='19.1447'
      y2='19.1447'
    />
  </svg>
)
